var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersThree02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7129_33093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66927 6.33565L1.33594 8.00232L7.76409 11.2164C7.85154 11.2601 7.89527 11.282 7.94114 11.2906C7.98176 11.2982 8.02345 11.2982 8.06407 11.2906C8.10994 11.282 8.15366 11.2601 8.24112 11.2164L14.6693 8.00232L11.3359 6.33565M4.66927 9.66899L1.33594 11.3357L7.76409 14.5497C7.85154 14.5935 7.89527 14.6153 7.94114 14.6239C7.98176 14.6315 8.02345 14.6315 8.06407 14.6239C8.10994 14.6153 8.15366 14.5935 8.24112 14.5497L14.6693 11.3357L11.3359 9.66899M1.33594 4.66899L7.76409 1.45491C7.85155 1.41118 7.89527 1.38932 7.94114 1.38072C7.98176 1.37309 8.02345 1.37309 8.06407 1.38072C8.10994 1.38932 8.15366 1.41118 8.24112 1.45491L14.6693 4.66899L8.24112 7.88306C8.15366 7.92679 8.10994 7.94866 8.06407 7.95726C8.02345 7.96488 7.98176 7.96488 7.94114 7.95726C7.89527 7.94866 7.85155 7.92679 7.76409 7.88306L1.33594 4.66899Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7129_33093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersThree02);
export default __webpack_public_path__ + "static/media/layers-three-02.77b389aa719616eceb23edd5cbb43c79.svg";
export { ForwardRef as ReactComponent };